module.exports = __webpack_public_path__ + "assets/img/driver-btn-5b306f2c.png";